import React from "react";
import servicesPageBanner from "../../assets/services-page-banner.png";

const ServicesBanner = () => {
  return (
    <div
      className="bg-cover bg-center my-8 mx-6 rounded-3xl h-[210px] sm:h-[300px] md:h-[70vh] lg:h-[500px]"
      style={{ backgroundImage: `url(${servicesPageBanner})` }}
    >
      {/* Container for the text elements */}
        {/* Top Section: Heading, Subheading and Sign Up Button */}
        <div className="h-full flex flex-col justify-center">
        <h1 className="font-bold text-white text-center text-xl sm:text-4xl md:text-5xl">GELS Strength & Services</h1>
        <div className="border-b-4 border-white-500 w-64 mx-auto mt-5"></div> 
      </div>
    </div>
  );
};

export default ServicesBanner;

